// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__VZ9wu","wrapper":"Footer_wrapper__1UzXs","text":"Footer_text__BdXqz","schoolsContainer":"Footer_schoolsContainer__8Zx_2"};